import { get } from "lodash";
import serverCall from "../serverCall";

const login = async (body) => {
  try {
    const response = await serverCall.post(`auth/admin/login`, body);

    const data = get(response, "data", null);

    if (data) {
      setDataToLocal(data);
    }
    return response;
  } catch (error) {
    throw error;
  }
};

const setDataToLocal = (data) => {
  const id = data.data._id;
  const email = data.data.email;
  const token = data.token;
  const username = data.data.firstName;
  const role = data.data.role;

  const userProfile = {
    token,
    email,
    username,
    id,
    role,
  };
  localStorage.setItem("admin_store", JSON.stringify(userProfile));
};

const AuthService = {
  login,
};

export default AuthService;
